export const states = Object.freeze({
  ACTIVE: 1,
  ARCHIVED: 0
})
